<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-large"
    title="CPA 5G SA一括ID登録"
  >
    <template v-slot:body="{ cancel }">
      <!-- BODY -->
      <v-card-text class="pa-0">
        <div class="modal-body">
          <v-container>
            <div class="my-3">
              <v-row>
                <v-col class="d-flex flex-row ga-2 justify-end">
                  <v-btn color="primary" @click="showRegHistories"
                    >登録履歴表示</v-btn
                  >
                  <v-btn :href="downloadUrl" download color="primary"
                    >テンプレートダウンロード</v-btn
                  >
                </v-col>
              </v-row>

              <validation-observer v-slot="{ handleSubmit }" as="div">
                <!-- ファイル送信日時 -->
                <v-row>
                  <v-col>
                    <app-badge
                      item="ファイル送信日時"
                      :isRequired="form.sendType === 'RESERVE'"
                      :isInfo="form.sendType === 'RESERVE'"
                      msg="・現在日時以降で1時間単位(0分固定)での指定
                          ・今日から1ヶ月後の23時まで指定可
                          ・00~23までの2桁で入力"
                    ></app-badge>
                    <v-radio-group v-model="form.sendType" hide-details>
                      <v-radio label="即時" value="IMMEDIATE" />
                      <v-radio label="送信日時指定" value="RESERVE" />
                    </v-radio-group>
                  </v-col>
                </v-row>
                <v-row no-gutters class="ml-2 ga-2">
                  <v-col cols="4">
                    <validation-provider
                      name="sendDate"
                      label="送信日"
                      v-model="form.sendDate"
                      :rules="{
                        required: form.sendType === 'RESERVE',
                        is_date_before: { date: maxDays },
                      }"
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-form-input
                        type="text"
                        onfocus="this.type='date'"
                        onblur="this.type='text'"
                        :placeholder="$filter.message('placeholder_date')"
                        :min="minSendDate"
                        @keydown.prevent
                        v-bind="componentField"
                        :field-meta="meta"
                        :error-messages="errorMessage"
                        :disabled="form.sendType !== 'RESERVE'"
                      />
                    </validation-provider>
                  </v-col>
                  <v-col cols="4">
                    <validation-provider
                      v-model="form.sendTime"
                      name="sendTime"
                      label="送信時間"
                      :rules="{
                        required: form.sendType === 'RESERVE',
                        is_hour_hh: true,
                        min_value: { min: minTime },
                      }"
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <div class="d-flex inline">
                        <app-form-input
                          :disabled="form.sendType !== 'RESERVE'"
                          placeholder="HH"
                          v-bind="componentField"
                          :field-meta="meta"
                          :error-messages="errorMessage"
                        />
                        <span class="pl-2 mt-2">:00</span>
                      </div>
                    </validation-provider>
                  </v-col>
                </v-row>

                <!-- 端末認証即時反映 -->
                <v-row>
                  <v-col>
                    <app-badge
                      item="端末認証即時反映"
                      :isRequired="false"
                      :isInfo="false"
                    />
                    <v-radio-group
                      v-model="form.isImmediateReflect"
                      :disabled="
                        form.sendType === 'RESERVE' ||
                        contractType !== 'CPA_NO_LIMIT'
                      "
                      inline
                    >
                      <v-radio label="無" :value="false" />
                      <v-radio label="有" :value="true" />
                    </v-radio-group>
                  </v-col>
                </v-row>

                <!-- 認証IDファイル -->
                <app-badge item="認証IDファイル" :isInfo="false" />
                <v-row>
                  <v-col cols="12">
                    <file-upload
                      ext=".csv"
                      @input="
                        (file: File | null) =>
                          handleSubmit(() => fileUploadCheck(file))
                      "
                    ></file-upload>
                    <v-alert class="mt-2" v-if="!!alertMsg" :text="alertMsg" />
                  </v-col>
                </v-row>
              </validation-observer>

              <!-- ID登録履歴  -->
              <v-divider v-if="showRegHisFlag" class="mt-3"></v-divider>
              <template v-if="showRegHisFlag">
                <v-row class="my-3">
                  <v-col>
                    <h3>登録履歴</h3>
                  </v-col>
                  <div class="d-flex flex-row ga-1 flex-wrap">
                    <v-btn
                      v-if="canCancel"
                      color="primary"
                      @click="cancelIdReservation"
                      size="small"
                      >予約キャンセル</v-btn
                    >
                  </div>
                </v-row>

                <v-row no-gutters>
                  <v-col>
                    <app-search
                      :search="idRegHitory.search"
                      v-model="idRegHitory.filter"
                      :initial-form="
                        () => ({
                          registrationDateTime: { start: null, end: null },
                        })
                      "
                    >
                      <!-- 一括登録時刻の期間検索 -->
                      <template #input(custom)="{ form }">
                        <v-row class="align-center justify-center">
                          <v-col>
                            <validation-provider
                              name="registrationDateTimeStart"
                              label="開始"
                              v-model="form['registrationDateTime']['start']"
                              :rules="{
                                required: true,
                                date_format: 'YYYY-MM-DDTHH:mm',
                              }"
                              v-slot="{ componentField, errorMessage, meta }"
                            >
                              <app-form-input
                                :hide-details="true"
                                type="datetime-local"
                                v-bind="componentField"
                                :error-messages="errorMessage"
                                :field-meta="meta"
                              ></app-form-input>
                            </validation-provider>
                          </v-col>
                          <span>〜</span>
                          <v-col>
                            <validation-provider
                              name="registrationDateTimeEnd"
                              label="終了"
                              v-model="form['registrationDateTime']['end']"
                              :rules="{
                                required: true,
                                date_format: 'YYYY-MM-DDTHH:mm',
                              }"
                              v-slot="{ componentField, errorMessage, meta }"
                            >
                              <app-form-input
                                :hide-details="true"
                                type="datetime-local"
                                v-bind="componentField"
                                :error-messages="errorMessage"
                                :field-meta="meta"
                              ></app-form-input>
                            </validation-provider>
                          </v-col>
                          <v-btn icon="$mdiMagnify" type="submit"></v-btn>
                        </v-row>
                      </template>
                      <!-- 一括登録時刻のタグ表示 -->
                      <template #tagValue(registrationDateTime)="{ value }">
                        {{ $filter.datetime(value.start) }} ~
                        {{ $filter.datetime(value.end) }}
                      </template>
                    </app-search>
                  </v-col>
                  <div class="d-flex flex-row ga-1 flex-wrap ml-1">
                    <v-btn @click="getRegHistories" color="primary"
                      >一覧更新</v-btn
                    >
                  </div>
                </v-row>
                <span v-if="isWarning" class="text-red"
                  >登録後、結果が反映されるまで10分ほどかかります。</span
                >
                <app-table
                  v-model:table-sort-by="idRegHitory.sortBy"
                  primary-key="_index"
                  :fields="idRegHitory.fields"
                  :items="idRegHitory.items"
                  :hover="true"
                  @click:row="regHistoryDetails"
                  :filter="idRegHitory.filter"
                  :filter-option="idRegHitory.filter_option"
                  :tr-class="historyRowClass"
                  density="compact"
                >
                  <!-- 処理種別 -->
                  <template #cell(sendType)="data">
                    {{ $filter.enumTo(data.value, "cpaIdSendType") }}
                  </template>

                  <!-- 一括登録時刻 -->
                  <template #cell(registrationDateTime)="data">
                    {{ $filter.datetime(data.value, { s: true }) }}
                  </template>

                  <!-- ステータス -->
                  <template #cell(status)="data">
                    {{ $filter.enumTo(data.value, "cpaIdStatus") }}
                  </template>
                </app-table>
              </template>
            </div>
          </v-container>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <!-- FOOTER -->
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn @click="cancel" variant="outlined" color="primary"
              >戻る</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import { VueFinalModal } from "vue-final-modal";
import SaIdRegisterHistoryReference from "@/modals/cpa5g/SaIdRegisterHistoryReference.vue";
import type {
  AppTableHeader,
  FilterOption,
  SortItem,
} from "@/components/AppTable.vue";
import type {
  ContractType,
  RegistrationResult,
  SendType,
} from "@/apis/Cpa5gSaApi";
import Encoding from "encoding-japanese";
import type { SearchOption } from "@/components/AppSearch.vue";

export default defineComponent({
  name: "SaIdRegister",
  props: {
    /** CPA契約SEQ */
    cpaContractSeq: {
      type: String as PropType<string>,
      required: true,
    },
    /** 契約タイプ */
    contractType: {
      type: String as PropType<ContractType>,
      required: true,
    },
  },
  data() {
    return {
      file: null as null | File,
      downloadUrl: this.$api.cpa5gSa.downloadCpaNwCsvURL(this.cpaContractSeq),
      showRegHisFlag: false,
      alertMsg: null as null | string,
      form: {
        sendType: "IMMEDIATE" as SendType,
        sendDate: "" as string | null,
        sendTime: "" as string | null,
        sendDateTime: "" as string | null,
        isImmediateReflect: false,
      },
      idRegHitory: {
        sortBy: {
          key: "registrationDateTime",
          order: "desc",
        } as SortItem,
        fields: [
          {
            key: "remoteServiceType",
            title: "サービス種別",
            sortable: true,
          },
          {
            key: "sendType",
            title: "処理種別",
            sortable: true,
          },
          {
            key: "registrationDateTime",
            title: "一括登録時刻",
            sortable: true,
          },
          {
            key: "status",
            title: "ステータス",
          },
        ] as AppTableHeader<RegistrationResult>[],
        items: [] as RegistrationResult[],
        search: {
          remoteServiceType: {
            type: "select",
            label: "サービス種別",
            items: [{ value: "CPA", text: "CPA" }],
          },
          sendType: {
            type: "select",
            label: "処理種別",
            items: [
              { value: "IMMEDIATE", text: "即時" },
              { value: "RESERVE", text: "送信日時指定" },
            ],
          },
          registrationDateTime: {
            type: "custom",
            label: "一括登録時刻",
          },
          status: {
            type: "select",
            label: "ステータス",
            items: [
              { value: "COMPLETE", text: "登録完了" },
              { value: "REGISTER", text: "登録中" },
              { value: "FAILURE", text: "登録エラー" },
              { value: "RESERVE", text: "予約中" },
              { value: "CANCEL", text: "予約キャンセル" },
            ],
          },
        } as SearchOption,
        filter: {} as Record<string, unknown>,
        filter_option: {
          remoteServiceType: "equal",
          sendType: "equal",
          registrationDateTime: (
            item: RegistrationResult,
            value: { start: string; end: string }
          ) => {
            return this.$moment(item.registrationDateTime).isBetween(
              this.$moment(value.start),
              this.$moment(value.end),
              undefined,
              "[]"
            );
          },
          status: "equal",
        } as FilterOption,
      },
    };
  },

  computed: {
    /**
     * true: 最新のステータス（表の最初の行のステータス）が予約中になっている場合
     * false: 最新のステータス（表の最初の行のステータス）が予約中以外になっている場合
     */
    canCancel(): boolean {
      return (
        this.idRegHitory.items.length > 0 &&
        this.idRegHitory.items[0].status === "RESERVE"
      );
    },
    /**
     * true: 最新のステータス（表の最初の行のステータス）が登録中になっている場合
     * false: 最新のステータス（表の最初の行のステータス）が登録中以外になっている場合
     */
    isWarning(): boolean {
      return (
        this.idRegHitory.items.length > 0 &&
        this.idRegHitory.items[0].status === "REGISTER"
      );
    },
    /** 当日以降の日付が選択可能 */
    minSendDate(): string {
      return this.$moment().format("YYYY-MM-DD");
    },

    /**
     * 時間指定の最小値
     * 当日の場合：現在時刻の時間+1
     * それ以外：指定無し
     * 例：現在が2022/09/16 10:35の場合
     * 日付の指定も2022/09/16の場合：11時以降を指定
     * 日付の指定は2022/09/17の場合：時間の制限は無し(0〜23まで指定可能)
     */
    minTime(): number {
      // フォーマットを入力に合わせて比較
      if (this.$moment().format("YYYY-MM-DD") === this.form.sendDate) {
        return this.$moment().hours() + 1;
      } else {
        return 0;
      }
    },
    /** 指定可能最大日数 */
    maxDays(): string {
      // moment-diffの仕様はミリ秒まで比較している
      // そして1ミリ秒でも差分が小さければ、1日としてカウントしないため、00秒で今日の日付を取得しておく
      return this.$moment().add(1, "M").format("YYYY-MM-DD");
    },
  },

  watch: {
    /** 送信元ゾーンが選択された際に宛先ゾーンが選択不可な値が入っていたらクリア */
    "form.sendType"(val: SendType) {
      if (val === "RESERVE") {
        /** 「送信日時指定」に変更した際、 端末認証即時反映をデフォルト値に設定する */
        this.form.isImmediateReflect = false;
      }
    },
  },

  methods: {
    /** ID登録予約キャンセル */
    async cancelIdReservation() {
      this.alertMsg = null;
      await this.$confirm(
        "ID登録予約のキャンセルを実施します。よろしいですか？"
      );
      await this.$api.cpa5gSa.cancelAuthIdReservation(
        this.cpaContractSeq,
        this.idRegHitory.items[0].fileKey
      );
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },

    /** 登録履歴表示 */
    async showRegHistories() {
      this.alertMsg = null;
      await this.getRegHistories();
      /** 登録履歴一覧を表示 */
      this.showRegHisFlag = true;
    },
    async getRegHistories() {
      this.alertMsg = null;
      this.idRegHitory.items = (
        await this.$api.cpa5gSa.getAuthIdRegistrationResult(this.cpaContractSeq)
      ).registrationResultList.sortBy(["registrationDateTime", "desc"]);
      // 主キー相当の項目が無いため、こちらでインデックスを作成
      this.idRegHitory.items.numbering();
    },

    /** 登録履歴詳細表示 */
    async regHistoryDetails(entity: RegistrationResult) {
      if (entity.status === "FAILURE") {
        this.alertMsg = null;
        await this.$modal.show(SaIdRegisterHistoryReference, {
          errorDetails: entity.errorDetailList,
        });
        await this.getRegHistories();
      }
    },

    /**
     * 一括ID登録のファイルアップロード処理
     * @param event イベントオブジェクト
     */
    async fileUploadCheck(file: File | null) {
      this.file = file;
      if (file) {
        // サイズが0の場合はエラー
        if (file.size === 0) {
          this.alertMsg = this.$filter.message("file_no_size");
          return;
        }
        // ファイルの拡張子がcsvではない場合エラー
        if (!file.name.endsWith("csv")) {
          this.alertMsg = this.$filter.message("file_invalid_format");
          return;
        }

        // 文字コードチェック
        const fileBuffer = await this.$service.file.readAsArrayBuffer(file);
        const encode = Encoding.detect(new Uint8Array(fileBuffer));
        // エディタ上UTF8であっても、ASCIIと互換性のある1バイト文字しか利用してない場合、結果がASCIIとなる為、
        // ASCIIも許容する。
        if (encode !== "UTF8" && encode !== "ASCII") {
          this.alertMsg = this.alertMsg = this.$filter.message("no_utf8_data");
          return;
        }

        this.alertMsg = null;

        await this.$confirm(
          `${file.name}の内容でIDの一括登録を行います。よろしいですか？
          ${
            this.form.sendType === "RESERVE"
              ? "なお、送信日時指定した一括ID登録は予約され、指定日時以降の5:00~7:00の間に処理が行われます。"
              : ""
          }`
        );

        const response = await this.$api.cpa5gSa.createAuthId(
          this.cpaContractSeq,
          this.form.sendType,
          this.form.sendType === "RESERVE"
            ? this.$moment(
                this.form.sendDate + " " + this.form.sendTime
              ).format("YYYY-MM-DDTHH:00:00+09:00")
            : null,
          this.form.isImmediateReflect,
          new TextDecoder().decode(fileBuffer)
        );
        // リクエストの形式は正しいが、ファイルの内容にエラーがある場合
        if (response.status === 200) {
          let msg =
            "ID登録を受理できませんでした。以下のエラー内容を確認し、再度登録をお願いします。\n";
          response.data.checkErrorList.forEach(
            (e: { rowNumber: number; checkErrorMessageList: string[] }) => {
              msg += `■${e.rowNumber}行目\n`;
              e.checkErrorMessageList.forEach((em) => {
                msg += `・${em}\n`;
              });
            }
          );
          await this.$confirm(msg, "エラー", true);
        } else {
          // 正常終了
          (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
        }
      } else {
        // ファイルが選択されていない場合エラー
        this.alertMsg = this.$filter.message("csv_no_select");
      }
    },

    /** 登録履歴テーブルのtrクラス */
    historyRowClass(item: RegistrationResult): string[] | undefined {
      switch (item.status) {
        case "FAILURE":
          return ["clickable"];
        default:
          return undefined;
      }
    },
  },
});
</script>
